import Inputmask from 'inputmask'

/**
@docs https://github.com/RobinHerbots/Inputmask
*/
const inputmaskPlugin = {
	install: function (Vue, options) {
		Vue.directive('mask', {
			mounted: function (el, binding) {
				if (binding.value && !binding.value.placeholder) {
					binding.value.placeholder = ''
				}
				Inputmask(binding.value).mask(el)
			}
		})
	}
}

export default inputmaskPlugin
